import { useTypedParams } from '@sorare/routing';
import { useIntlContext } from '@sorare/core/src/contexts/intl';

import { Post } from '#src/components/Post/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const Preview = () => {
  const { slug } = useTypedParams<PageParams>();
  const { language } = useIntlContext();
  return <Post preview slug={slug} language={language} />;
};

export default Preview;
